<template>
  <div>
    <pie-chart :chart-data="datacollection"></pie-chart>
  </div>
</template>

<script>
import PieChart from './PieChart.js'

export default {
    components: {
      PieChart
    },
    data () {
      return {
        datacollection: {}
      }
    },
    mounted () {
      this.fillData()
    },
    methods: {
      doSomething () {
        alert('ciao')
      },
      fillData (catData) {
        var names = []
        var values = []
        var colors = []
        for (var i in catData) {
          names.push(catData[i].description)
          values.push((catData[i].amount / 1000).toFixed(2))
          colors.push(this.pastelColors())
        }
        this.datacollection = {
          labels: names,
          datasets: [{
            label: 'Data One',
            backgroundColor: colors,
            data: values}
          ]
        }
      },
      getRandomInt () {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      },
      getRandomColor: function () {
        var letters = '0123456789ABCDEF'
        var color = '#'
        for (var i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)]
        }
        return color
      },
      pastelColors: function () {
        var r = (Math.round(Math.random() * 127) + 127).toString(16)
        var g = (Math.round(Math.random() * 127) + 127).toString(16)
        var b = (Math.round(Math.random() * 127) + 127).toString(16)
        return '#' + r + g + b
      }
    }
  }
</script>
